import { createRouter, createWebHistory } from 'vue-router'
import { RESTRICTED_CATEGORIES } from '@/config/restrictedCategories'

// Gera uma rota dedicada para cada categoria restrita configurada.
// Adicionar uma nova categoria em config/restrictedCategories.js cria a rota
// automaticamente (ex.: /diretoria -> RestrictedCategoryView).
const restrictedRoutes = RESTRICTED_CATEGORIES.map((cat) => ({
  path: cat.path,
  name: cat.routeName,
  component: () => import('@/views/RestrictedCategoryView.vue'),
  props: { categorySlug: cat.slug },
}))

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/PostsView.vue')
  },
  {
    path: '/auth/:redirect?',
    name: 'Authentication',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/register/:sociocategoria?',
    name: 'Cadastro',
    component: () => import('@/views/RegisterView.vue')
  },
  {
    path: '/profile/settings',
    name: 'Settings',
    component: () => import('@/views/SettingsView.vue')
  },
  {
    path: '/profile/account',
    name: 'Profile',
    component: () => import('@/views/ProfileView.vue')
  },
  {
    path: '/post/:slug',
    name: 'Post',
    component: () => import('@/views/PostView.vue'),
  },
  {
    path: '/category/:slug?',
    name: 'Posts',
    component: () => import('@/views/PostsCategoryView.vue'),
  },
  {
    path: '/password-reset/:tokenPass?',
    name: 'Reset Password',
    component: () => import('@/views/PasswordResetView.vue')
  },
  {
    path: '/centros-de-dialise',
    name: 'Centros de diálise',
    component: () => import('@/views/CentroDialiseView.vue')
  },
  ...restrictedRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'Error 404',
    component: () => import('@/views/Error404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0) // Isso fará a rolagem para o topo da página
  next()
})

export default router
